import InfoBlock from "../../../../src/components/custom-blocks/info-block";
import PropsAttributes from "../../../../src/posts/2019-10-17-jsx-html-differences/props-attributes.mdx";
import * as React from 'react';
export default {
  InfoBlock,
  PropsAttributes,
  React
};